<template>
    <div>
        <div id="proposal-settings-template-settings-div" class="p-4 shadow-md" v-if="!loadingTemplateInformation">
            <div class="row">
                <div class="col-md-12 float-left">
                    <h5>{{proposalTemplate.name}} settings</h5>
                </div>
            </div>
            <div class="proposal-template-listing-div mt-3 col-md-12 p-0 text-black">
                <p>Proposal Graphics</p>
                <p class="text-sm font-weight-light mt-2">*Recommended size for Header and Footer Image 1800px width and 200px height. If the header or footer image is turned off then it will not appear in proposal pdf review.</p>
            </div>
            <div class="proposal-template-listing-div mt-4 col-md-12 p-0 text-black">
                <div class="p-0 col-md-6 float-left">
                    <p class="text-sm mb-2">Proposal Header</p>
                </div>
                <div class="p-0 col-md-6 float-left text-right">
                    <b-form-checkbox @change="updateHeaderSwitch()" name="check-button" v-model="headerSwitch" id="headerSwitch" class="inline-block p-0" switch>
                    </b-form-checkbox>
                    <label for="headerSwitch" class="inline-block text-black font-weight-light cursor-pointer">{{headerSwitchText}}</label>
                </div>
                <div v-if="templateInfo.header_image_url" class="border-1 border-grey overflow-hidden col-md-12" style="height: 120px;border-radius: 2px">
                    <div class="col-md-8 float-left overflow-hidden p-0 h-100">
                        <div class="col-md-7 float-left overflow-hidden p-0 h-100">
                            <div :style="'background-image:url('+templateInfo.header_image_url+'?'+randomInt+');background-size: contain;height: 100%;width: 380px;background-repeat: no-repeat;background-position-y: center;'"></div>
                        </div>
                        <div class="col-md-5 float-left overflow-hidden p-0 h-100 py-5 text-teal">
                            {{headerImageName}}
                        </div>
                    </div>
                    <div class="col-md-4 float-left text-right p-0 h-100">
                            <span @click.prevent="deleteImageButton('header_image_url')" class="material-icons text-black col-1 cursor-pointer py-5">
                                delete
                            </span>
                    </div>
                </div>
                <div v-else class="border-1 border-grey overflow-hidden col-md-12 anka-div" style="border-radius: 2px">
                    <image-cropper
                        :url="headerFooterImageUploadUrl"
                        :image-type="'header'"
                        :proposal-template-id="proposalTemplate.id"
                    ></image-cropper>
                </div>
            </div>
            <div class="proposal-template-listing-div mt-4 col-md-12 p-0 text-black">
            <div class="p-0 col-md-6 float-left">
                <p class="text-sm mb-2">Proposal Footer</p>
            </div>
            <div class="p-0 col-md-6 float-left text-right">
                <b-form-checkbox @change="updateFooterSwitch()" name="check-button" v-model="footerSwitch" id="footerSwitch" class="inline-block p-0" switch>
                </b-form-checkbox>
                <label for="footerSwitch" class="inline-block text-black font-weight-light cursor-pointer">{{footerSwitchText}}</label>
            </div>
            <div v-if="templateInfo.footer_image_url" class="border-1 border-grey overflow-hidden col-md-12" style="height: 120px;border-radius: 2px">
                <div class="col-md-8 float-left overflow-hidden p-0 h-100">
                    <div class="col-md-7 float-left overflow-hidden p-0 h-100">
                        <div :style="'background-image:url('+templateInfo.footer_image_url+'?'+randomInt+');background-size: contain;height: 100%;width: 380px;background-repeat: no-repeat;background-position-y: center;'"></div>
                    </div>
                    <div class="col-md-5 float-left overflow-hidden p-0 h-100 py-5 text-teal">
                        {{footerImageName}}
                    </div>
                </div>
                <div class="col-md-4 float-left text-right p-0 h-100">
                        <span @click.prevent="deleteImageButton('footer_image_url')" class="material-icons text-black col-1 cursor-pointer py-5">
                            delete
                        </span>
                </div>
            </div>
            <div v-else class="border-1 border-grey overflow-hidden col-md-12 anka-div" style="border-radius: 2px">
                <image-cropper
                    :url="headerFooterImageUploadUrl"
                    :image-type="'footer'"
                    :proposal-template-id="proposalTemplate.id"
                ></image-cropper>
            </div>
        </div>

            <div class="proposal-template-listing-div mt-4 col-md-12 p-0 text-black">
                <div class="p-0 col-md-12 float-left">
                    <p class="text-sm mb-2">Proposal Cover Page Logo</p>
                </div>
                <div v-if="templateInfo.cover_page_logo" class="border-1 border-grey overflow-hidden col-md-12" style="height: 120px;border-radius: 2px">
                    <div class="col-md-8 float-left overflow-hidden p-0 h-100">
                        <div class="col-md-7 float-left overflow-hidden p-2 h-100">
                            <div :style="'background-image:url('+templateInfo.cover_page_logo+'?'+randomInt+');background-size: contain;height: 100%;width: auto;background-repeat: no-repeat;background-position-y: center;'"></div>
                        </div>
                        <div class="col-md-5 float-left overflow-hidden p-0 h-100 py-5 text-teal">
                            {{coverPageImageName}}
                        </div>
                    </div>
                    <div class="col-md-4 float-left text-right p-0 h-100">
                        <span @click.prevent="deleteImageButton('cover_page_logo')" class="material-icons text-black col-1 cursor-pointer py-5">
                            delete
                        </span>
                    </div>
                </div>
                <div v-else class="border-1 border-grey overflow-hidden col-md-12 anka-div" style="border-radius: 2px">
                    <image-cropper
                        :url="headerFooterImageUploadUrl"
                        :image-type="'cover'"
                        :proposal-template-id="proposalTemplate.id"
                    ></image-cropper>
                </div>
            </div>

            <div class="proposal-template-listing-div mt-4 col-md-12 p-0 text-black">
                <p>Proposal Email Template</p>
                <p class="text-sm font-weight-light mt-2">*You can turn off/on and change the image in proposal template and can change the name at the bottom of the email.</p>
            </div>
            <div class="proposal-template-listing-div mt-4 col-md-12 p-0 text-black overflow-hidden">
                <div class="p-0 col-md-6 float-left">
                    <p class="text-sm mb-2">Proposal Email Image</p>
                </div>
                <div class="p-0 col-md-6 float-left text-right">
                    <b-form-checkbox @change="updateEmailImageSwitch()" name="check-button" v-model="emailImageSwitch" id="emailImageSwitch" class="inline-block p-0" switch>
                    </b-form-checkbox>
                    <label for="headerSwitch" class="inline-block text-black font-weight-light cursor-pointer">{{emailImageSwitchText}}</label>
                </div>
            </div>
            <div class="proposal-template-email-template bg-grey-lighter rounded p-4 mt-1 text-right">
                <div class="email-template-div text-center bg-white rounded-lg w-2/3 m-auto p-4 text-grey-darker">
                    <div class="" v-if="emailImage && emailImageSwitch">
                        <img :src="emailImage" class="emailImage">
                    </div>
                    <div v-else-if="!emailImage && emailImageSwitch" class="">
                        <file-pond v-if="showTemplateImageUploader"
                            name="emailImage"
                            ref="emailImageResource"
                            label-idle="Drop photo here or click to upload from your computer. <br><i class='fa fa-upload upload-icon-proposal'></i>"
                            :server="emailImageResourceServer"
                            @processfile="handleOnProcessResourceFile"
                            :onaddfilestart="handleOnAddFileStart"
                            dropOnPage="false"
                            allow-multiple="false"
                            dropOnElement="true"
                            allowRevert="false"
                            allowRemove="false"
                            allowReorder="false"
                            accepted-file-types="image/jpeg, image/png, image/jpg, image/webp"
                        />
                    </div>
                    <span v-if="emailImage && emailImageSwitch" class="text-2xl text-red email-template-tooltip" title="Remove email image" @click="removeEmailImage()"><i class="fa fa-trash" aria-hidden="true"></i></span>

                    <p class="text-lg font-weight-bold mt-4 email-template-tooltip" >
                        <input type="text" class="text-center bg-yellow-lighter w-64 p-2 rounded-lg d-block m-auto font-weight-bold text-lg mt-4" v-model="emailTeamName">
                    </p>
                    <p class="text-sm mt-4 cursor-not-allowed email-template-tooltip" title="You can edit image and name only">To review this quote, click on the button below.</p>
                    <p class="btn btn-primary text-sm font-weight-light mt-4 cursor-not-allowed email-template-tooltip" title="You can edit image and name only">See Quote</p>
                    <p class="text-sm mt-4 cursor-not-allowed email-template-tooltip" title="You can edit image and name only">If you have any questions regarding this quote, you can email {{user.name}} at {{user.email}}</p>
                    <p class="text-sm mt-4 cursor-not-allowed email-template-tooltip" title="You can edit image and name only">Thanks</p>
                    <input type="text" class="mt-1 text-sm text-center bg-yellow-lighter w-64 p-2 rounded-lg" v-model="emailName">
                </div>
                <button @click="updateEmailName()" class="btn btn-primary mt-4">Update Email Template</button>
            </div>
        </div>
        <div id="proposal-settings-template-settings-div" class="p-4 shadow-md" v-else>
            <div class="text-center text-black text-xl">Loading Proposal Template Settings</div>
            <div class="text-center text-black text-xl"><i class="fa fa-spin fa-spinner text-grey-darkest" aria-hidden="true"></i></div>
        </div>
    </div>
</template>

<script>

import ImageCropper from "../../shared/image-cropper.vue";
import axios from "axios";
let token = document.head.querySelector('meta[name="csrf-token"]');

export default {
    name: "proposal-settings-template-settings",
    props:['proposalTemplate', 'baseUrl', 'team', 'headerFooterImageUploadUrl', 'user'],
    components: {ImageCropper},
    data() {
        return {
            templateInfo: this.proposalTemplate,
            headerSwitch:(this.proposalTemplate.header_image_show == 1)? true:false,
            headerSwitchText:(this.proposalTemplate.header_image_show == 1)? 'On':'Off',
            footerSwitch:(this.proposalTemplate.footer_image_show == 1)? true:false,
            footerSwitchText:(this.proposalTemplate.footer_image_show == 1)? 'On':'Off',
            headerImageName:(this.proposalTemplate.header_image_url)? this.proposalTemplate.header_image_url.split('/')[this.proposalTemplate.header_image_url.split('/').length-1]:'',
            footerImageName:(this.proposalTemplate.footer_image_url)? this.proposalTemplate.footer_image_url.split('/')[this.proposalTemplate.footer_image_url.split('/').length-1]:'',
            randomInt:Math.floor(Math.random() * 100),
            loadingTemplateInformation: true,
            emailImageSwitch:(this.proposalTemplate.email_image_show == 1)? true:false,
            emailImageSwitchText:(this.proposalTemplate.email_image_show == 1)? 'On':'Off',
            emailImage: (this.proposalTemplate.email_image)? this.proposalTemplate.email_image:'',
            emailName: (this.proposalTemplate.email_name)? this.proposalTemplate.email_name:this.team.name,
            emailImageResourceServer: {
                process: (fieldName, file, metadata, load, error, progress)=> {
                    const formData = new FormData();
                    if (this.proposalTemplate) formData.append('proposalTemplateId', this.proposalTemplate.id);
                    formData.append(fieldName, file, file.name);

                    const request = new XMLHttpRequest();
                    request.open('POST', '/api/proposal-settings/proposal-template-setting/upload-email-image');
                    request.setRequestHeader('X-CSRF-TOKEN', token.content);

                    request.upload.onprogress = (e) => {
                        progress(e.lengthComputable, e.loaded, e.total);
                    };
                    request.onload = function () {
                        if (request.status >= 200 && request.status < 300) {
                            load(request.responseText);
                        } else {
                            error('oh no');
                        }
                    };

                    request.onreadystatechange = function () {
                        if (request.readyState === 4) {
                            if (request.status === 200) {
                                var responseText = request.responseText;
                                var resData = JSON.parse(responseText);
                                Bus.$emit('templateImageUploadData', resData)
                            }
                        }
                    };

                    request.send(formData);

                }
            },
            showTemplateImageUploader: true,
            emailTeamName: (this.team.name)? this.team.name:'',
            coverPageImageName:(this.proposalTemplate.cover_page_logo)? this.proposalTemplate.cover_page_logo.split('/')[this.proposalTemplate.cover_page_logo.split('/').length-1]:'',
        }
    },
    mounted(){
        this.fetchPGTemplateInfo();
        Bus.$on('templateImageUploadData',data => {
            this.dataFromTemplateImageUploader(data);
        });
    },
    methods: {
        fetchPGTemplateInfo(){
            this.loadingTemplateInformation = true;
            axios.post(route('api.proposal-settings.template-info'), {proposalTemplateId: this.proposalTemplate.id}).then((response) => {
                this.updateTemplateInformation(response);
            });
        },
        updateHeaderSwitch(){
            this.$nextTick(()=>{
                var data = {
                    'type':'header',
                    'show': (this.headerSwitch)? 1:0,
                    'proposalTemplateId': this.proposalTemplate.id
                };
                axios.post(route('api.proposal-template-setting.turn-on-off-header-footer-image'), data).then(
                    (response) => {
                        this.getToast().fire({
                            type: 'success',
                            title: response.data.message
                        });
                        this.updateTemplateInformation(response);
                    }
                );
            });
        },
        updateFooterSwitch(){
            this.$nextTick(()=>{
                var data = {
                    'type':'footer',
                    'show': (this.footerSwitch)? 1:0,
                    'proposalTemplateId': this.proposalTemplate.id
                };
                axios.post(route('api.proposal-template-setting.turn-on-off-header-footer-image'), data).then(
                    (response) => {
                        this.getToast().fire({
                            type: 'success',
                            title: response.data.message
                        });
                        this.updateTemplateInformation(response);
                    }
                );
            });
        },
        updateEmailImageSwitch(){
            this.$nextTick(()=>{
                var data = {
                    'type':'email',
                    'show': (this.emailImageSwitch)? 1:0,
                    'proposalTemplateId': this.proposalTemplate.id
                };
                axios.post(route('api.proposal-template-setting.turn-on-off-header-footer-image'), data).then(
                    (response) => {
                        this.getToast().fire({
                            type: 'success',
                            title: response.data.message
                        });
                        this.updateTemplateInformation(response);
                    }
                );
            });
        },
        deleteImageButton(type){
            axios.post(route('api.proposal-template-setting.delete-header-footer-image'), {
                type: type,
                proposalTemplateId: this.proposalTemplate.id
            }).then((response) => {
                    this.getToast().fire({
                        type: 'success',
                        title: response.data.message
                    });
                    this.updateTemplateInformation(response);
                }
            );
        },
        updateTemplateInformation(templateInfo){
            this.templateInfo = templateInfo.data.proposalTemplate;
            this.headerSwitch = (templateInfo.data.proposalTemplate.header_image_show == 1)? true:false;
            this.headerSwitchText = (templateInfo.data.proposalTemplate.header_image_show == 1)? 'On':'Off';
            this.footerSwitch = (templateInfo.data.proposalTemplate.footer_image_show == 1)? true:false;
            this.footerSwitchText = (templateInfo.data.proposalTemplate.footer_image_show == 1)? 'On':'Off';
            this.emailImageSwitch = (templateInfo.data.proposalTemplate.email_image_show == 1)? true:false;
            this.emailImageSwitchText = (templateInfo.data.proposalTemplate.email_image_show == 1)? 'On':'Off';
            this.emailImage = (templateInfo.data.proposalTemplate.email_image)? templateInfo.data.proposalTemplate.email_image:'';
            this.emailName = (templateInfo.data.proposalTemplate.email_name !== '' && templateInfo.data.proposalTemplate.email_name)? templateInfo.data.proposalTemplate.email_name:this.team.name;
            this.emailTeamName = (templateInfo.data.proposalTemplate.email_team_name !== '' && templateInfo.data.proposalTemplate.email_team_name)? templateInfo.data.proposalTemplate.email_team_name:this.team.name;
            this.loadingTemplateInformation = false;
            $('.email-template-tooltip').tooltip();
        },
        updateEmailName(){
            this.$nextTick(()=>{
                if(this.emailName.trim() !== '' && this.emailName !== null && this.emailName !== undefined){
                    var data = {
                        'emailName':this.emailName.trim(),
                        'proposalTemplateId': this.proposalTemplate.id,
                        'emailTeamName':this.emailTeamName.trim(),
                    };
                    axios.post(route('api.proposal-template-setting.update-email-template'), data).then(
                        (response) => {
                            this.getToast().fire({
                                type: 'success',
                                title: response.data.message
                            });
                            this.updateTemplateInformation(response);
                        }
                    );
                }else{
                    this.getToast().fire({
                        type: 'error',
                        title: 'Please provide valid text for email template.'
                    });
                    return false;
                }
            });
        },
        handleOnProcessResourceFile() {
        },
        handleOnAddFileStart() {

        },
        removeEmailImage(){
            this.emailImage = null;
        },
        dataFromTemplateImageUploader(data){
            this.getToast().fire({
                type: 'success',
                title: 'Email image uploaded successfully'
            });
            let templateInfo = {
                data: {
                    proposalTemplate: data.proposalTemplate
                }
            };
            this.updateTemplateInformation(templateInfo);
            this.showTemplateImageUploader = false;
            this.showTemplateImageUploader = true;
        }
    }
};
</script>

<style>
#proposal-settings-template-settings-div {
    padding: 5px 0;
}
#proposal-settings-template-settings-div h5{
    color: #222;
    font-weight: 400;
    padding: 5px 0px;
}
#proposal-settings-template-settings-div .add-new-template-button{
    height: 40px;
    font-weight: 300;
}
.proposal-template-listing-heading-row{
    background: #f4f5f6;
    font-weight: 500;
}
.proposal-template-listing-row {
    font-weight: 300;
}
.proposal-template-listing-row .dropdown-item {
    font-weight: 300;
    font-size: 15px;
}
.proposal-template-listing-row:hover {
    background: #f5f5f5;
}

.red-box-shadow{
    box-shadow: 0px 0px 5px #01b1af;
}
.ankaCropper__droparea {
    border: none !important;
    margin: 0 !important;
    padding: 1em !important;
}
.ankaCropper.light {
    background: transparent !important;
}
.ankaCropper {
    box-shadow: none !important;
    border-radius: 0px !important;
    font-family: inherit !important;
}
.anka-div{
    background: #f8f9fa;
}
.ankaCropper.light .ankaCropper__saveButton,
.ankaCropper.light .ankaCropper__selectButton,
.ankaCropper.light .ankaCropper__selectButton svg.feather.feather-save,
.ankaCropper > svg{
    border: 1px solid #01b1af !important;
    background: transparent !important;
    color: #01b1af !important;
    stroke: #01b1af !important;
}
.ankaCropper.light .ankaCropper__saveButton:hover,
.ankaCropper.light .ankaCropper__selectButton:hover,
.ankaCropper.light .ankaCropper__selectButton:hover svg.feather.feather-save {
    background: #01b1af !important;
    color: white !important;
    stroke: white !important;
}
.ankaCropper__droparea div {
    font-weight: 300;
    background-image: url('https://stage.followupcrm.com/images/image-upload.png');
    background-repeat: no-repeat;
    background-position-x: center;
    height: 60px;
    background-size: 5%;
    padding-top: 61px;
    margin-bottom: 30px;
}
.ankaCropper.light .ankaCropper__navigation {
    background: transparent;
    box-shadow: none;
}

#proposal-settings-template-settings-div .custom-control-input:checked ~ .custom-control-label::before {
    color: #fff !important;
    background-color: #01b1af !important;
    border-color: #01b1af !important;
}
svg.feather.feather-save{
    background: transparent !important;
    color: #01b1af !important;
    stroke: #01b1af !important;
}

.ankaCropper__saveButton:hover svg.feather.feather-save{
    background: #01b1af !important;
    color: white !important;
    stroke: white !important;
}
img.emailImage {
    max-width: 170px;
    width: 100%;
}
</style>
